import PropTypes from "prop-types";
import { Card } from "@mui/material";
import ReactApexChart from "react-apexcharts";
import "react-calendar/dist/Calendar.css";
import dayjs from "dayjs";
import "./CandleChart.scss";
import { FormatUSD } from "../../../utilities/string";

const CandleChart = ({ data = []  }) => {
 
  const options = {
    series: [
      {
        name: "Revenue Generated",
        data: data.map((item) => ({
          x: new Date(item.date).getTime(),
          y: item.revenue,
        })),
      },
      {
        name: "Commission Earned",
        data: data.map((item) => ({
          x: new Date(item.date).getTime(),
          y: item.commission,
        })),
      },
    ],
    colors: ["#0D56EB", "#FFC107"],
    chart: {
      type: "bar",
      height: 350,
      toolbar: {
        show: true,
        tools: {
          download: false,
          selection: true,
          zoom: true,
          zoomin: true,
          zoomout: true,
          pan: true,
          reset: true,
        },
      },
      zoom: {
        enabled: true,
        type: "x",
        autoScaleYaxis: true,
      },
    },
    title: {
      align: "left",
      style: {
        color: "#FFFFFF",
        fontSize: "16px",
        fontWeight: "bold",
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
        borderRadiusApplication: "end",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    xaxis: {
      type: "datetime",
      labels: {
        style: {
          colors: "#FFFFFF",
        },
      },
    },
    yaxis: {
      title: {
        text: "Revenue / Commission",
        style: {
          color: "#FFFFFF",
        },
      },
      labels: {
        style: {
          colors: "#FFFFFF",
        },
        formatter: (val) => FormatUSD(val),
      },
    },
    fill: {
      opacity: 1,
      colors: ["#0D56EB", "#FFC107"],
    },
    tooltip: {
      x: {
        formatter: (val) => dayjs(val).format("DD-MM-YYYY"),
      },
      y: {
        formatter: (val) => FormatUSD(val),
      },
    },
    legend: {
      labels: {
        colors: "#FFFFFF",
      },
    },
  };



  return (
    <Card className="pushleads-chart">
      <div className="filter_wrapper">
        <p>Revenue & Commission</p>
      </div>

      <ReactApexChart
        className="reactChart_div"
        options={options}
        series={options.series}
        type="bar"
        height={220}
      />
    </Card>
  );
};

CandleChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string.isRequired,
      commission: PropTypes.number.isRequired,
      revenue: PropTypes.number.isRequired,
    })
  ),
  params: PropTypes.shape({
    start_date: PropTypes.string,
    end_date: PropTypes.string,
  }).isRequired,
  setParams: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

CandleChart.defaultProps = {
  data: [],
  isLoading: false,
};

export default CandleChart;
